import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	type?: 'danger' | 'warning'
}

export const InfoBox = styled.div<Props>`
	display: flex;
	align-items: center;
	background-color: ${({ type = 'action', theme }) => {
		switch (type) {
			case 'danger':
				return theme.color.danger
			case 'warning':
			default:
				return theme.color.warning
		}
	}};
	border-radius: ${helpers.borderRadius};
	padding: ${helpers.spacing.small};
	color: ${helpers.color.actionLabel};
	column-gap: ${helpers.spacing.small};
	margin-bottom: ${helpers.spacing.large};

	> svg {
		align-self: flex-start;
	}
`
